import isProduction from '@tools/isProduction';
import type { GetServerSidePropsContext } from 'next';
import getConfig from 'next/config';
import { setCookieHeader } from './setCookieHeader';

const { publicRuntimeConfig } = getConfig();

export default function parseEnvironment(context: GetServerSidePropsContext): string {
  let environment = publicRuntimeConfig.DEFAULT_ENVIRONMENT;
  const userEnvironment = context.query.environment || context.req.cookies.environment;
  if (!isProduction(environment) && userEnvironment) {
    if (context.query.environment === 'sg50') {
      environment = 'T2';
    } else if (userEnvironment !== environment) {
      environment = Array.isArray(userEnvironment) ? userEnvironment[0] : userEnvironment;
    }
    setCookieHeader(context.res, [`environment=${environment};Path=/;Max-Age=86400`]);
  }
  return environment;
}
